<template>
  <div>
    <div v-if="news.length" class="fill-height px-4 pt-3">
      <div class="display-1 font-weight-bold hidden-sm-and-down pb-4">
        Новости
      </div>
      <div v-for="item in news" :key="item.id" class="font-weight-medium">
        <a v-if="item.url" :href="item.url" class="link text--primary">
          {{ item.title }}
          <div v-html="item.short_text" class="pt-1"></div>
        </a>
        <div v-if="!item.url">
          {{ item.title }}
          <div v-html="item.short_text" class="pt-1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "News",

  components: {},

  props: {},

  data: () => ({}),

  mounted() {
    this.$store.dispatch("newsListLoad");
  },

  computed: {
    news() {
      return this.$store.getters.newsList.map(item => {
        // unescape
        const text = item.text.replace(
          /&amp;|&lt;|&gt;|&#39;|&quot;/g,
          tag =>
            ({
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&#39;": "'",
              "&quot;": '"'
            }[tag] || tag)
        );

        return { ...item, text: text };
      });
    }
  },

  methods: {}
};
</script>
